import { useState, useMemo, FC } from 'react';
import './login-header.scss';
import { Box, Stack } from '@mui/material';
import { Link } from '../../../survey-tool/declarations/ah-api';
import { useAppSelector } from '../../../store';
import { screenSize } from '../../../survey-tool/styles/settings';
import { LanguagePicker } from '../../../components/header/language-picker';

interface LoginHeaderProps {
  logo: string;
  links: Link[];
  hideNavbar?: boolean;
}

const LoginHeader: FC<LoginHeaderProps> = ({ logo, links, hideNavbar }) => {
  const isPoweredByPP = useAppSelector((state) => state.panelInfo.app_settings.use_powered_by_pp_image);
  const poweredByPPUrl = useAppSelector((state) => state.panelInfo?.app_theme.powered_by_pp_image_login_url);
  const [collapsed, setCollapsed] = useState(true);
  const panelInfo = useAppSelector((state) => state.panelInfo);

  const onSandwichClick = () => {
    setCollapsed(!collapsed);
  };

  const renderNav = useMemo(() => {
    let menuClass = 'nav navbar-nav';
    if (collapsed) {
      menuClass += ' closed';
    }
    return (
      <nav className="collapse navbar-collapse" role="navigation">
        <ul id="main-navigation" className={menuClass}>
          {links.map(
            (link, index) =>
              link.show_on_nav_bar && (
                <li key={index}>
                  <a href={link.url} rel="noopener noreferrer" target="_blank">
                    {link.name}
                  </a>
                </li>
              )
          )}
        </ul>
      </nav>
    );
  }, [links, collapsed]);

  return (
    <header className="banner navbar navbar-default navbar-fixed-top login-header" role="banner">
      <div className="container">
        <div className="language-picker-container">
          <LanguagePicker />
        </div>
        <div className="navbar-header">
          <Stack direction="row" justifyContent="center" spacing={1}>
            {logo && (
              <a className="navbar-brand" href={panelInfo.login_page_url}>
                <img x-name="login-header-logo" src={logo} alt="" className="logo" />
              </a>
            )}
            {!!isPoweredByPP && (
              <Box ml={2} sx={styles.logos}>
                <Box component="img" alt="" sx={styles.image} src={poweredByPPUrl} />
              </Box>
            )}
          </Stack>
          {hideNavbar ? null : (
            <button
              type="button"
              className={collapsed ? '' : 'active'}
              data-toggle="collapse"
              aria-label="menu"
              aria-expanded="false"
              aria-controls="navbar"
              onClick={onSandwichClick}
            >
              <span className="icon-bar" />
            </button>
          )}
        </div>
        {renderNav}
      </div>
    </header>
  );
};

const styles = {
  image: {
    height: 'auto',
    maxHeight: 32,
    maxWidth: '100%',
    objectFit: 'scale-down',
  },
  logos: {
    [screenSize.desktopOrTablet]: {
      alignItems: 'center',
      display: 'flex',
    },
    '@media (min-width: 992px)': {
      paddingLeft: '0 !important',
    },
    display: 'none',
    padding: '0 16px',
  },
} as const;

export default LoginHeader;
